<template>
  <div class="minePage">
    <mythead :userInfo="userInfo" v-if="false"></mythead>
    <!-- <div class="company_column"> -->
    <div
      class="company_column"
      v-if="userAgent != 'other' && !userCompanyCard.id"
    >
      <div class="title flex-between">
        <div class="txt">用户企业/团队管理</div>
      </div>
      <div class="btn_group">
        <div class="wx_register flex-rowc" @click="handleCreateQy">
          <div class="icon">
            <van-image
              width="100%"
              height="100%"
              :src="require('../../assets/images/qw_logo.png')"
            />
          </div>
          企业微信一键授权<span>[创建企业]</span>
        </div>
        <div class="wx_register flex-rowc" @click="handleJoinQy">
          <div class="icon">
            <van-image
              width="100%"
              height="100%"
              :src="require('../../assets/images/qw_logo.png')"
            />
          </div>
          企业微信一键授权<span>[加入企业]</span>
        </div>
      </div>
    </div>

    <div class="company_column">
      <div class="title flex-between">
        <div class="txt">企业信息</div>
        <router-link
          class="flex-rowc edit"
          to="/companyIndex/companyEdit"
          v-if="userCompanyCard.checkrole == '创建人'"
          ><i class="iconfont icon-edit"></i> 编辑</router-link
        >
      </div>
      <div class="card_box">
        <div class="no" v-if="!userCompanyCard.id">
          <router-link
            to="/companyIndex/companyEdit"
            class="custom_btn flex-rowc"
            >创建企业/团队名片 <i class="iconfont icon-xinjian"></i
          ></router-link>
          <router-link
            to="/companyIndex/Csearch/companyList"
            class="custom_btn flex-rowc"
            >加入企业or团队<i class="iconfont icon-xingtuxuetang-jiaru-"></i
          ></router-link>
        </div>
        <!-- <div class="company_wrapper" v-else> -->
        <div
          class="company_wrapper"
          v-else-if="userCompanyCard.id && !isLoading"
        >
          <div v-if="userCompanyCard.checkstate == '审核中'">
            <div
              class="primary-button"
              @click="handleDetail(userCompanyCard.id)"
            >
              企业申请加入中
            </div>
          </div>
          <div v-else>
            <div class="certification_state flex-rowc">
              <i class="iconfont icon-yonghuzhongxin"></i>
              {{ userCompanyCard.checklabel }}
            </div>
            <div class="company_upper flex-rowl">
              <div class="img_box" v-if="userCompanyCard.logo">
                <van-image
                  :src="baseUrl + userCompanyCard.logo"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="intro">
                <div class="row">
                  <div class="subTit">企业名称：</div>
                  <div class="txt">{{ userCompanyCard.qyname }}</div>
                </div>
                <div class="row">
                  <div class="subTit">企业名称英文/缩写：</div>
                  <div class="txt">{{ userCompanyCard.qyename }}</div>
                </div>
              </div>
            </div>
            <div class="company_content_info">
              <!-- <div class="row flex-rowl">
                <div class="txt">商家类型：</div>
                <div class="right">
                  <div class="con"></div>
                </div>
              </div> -->

              <div class="row flex-rowl">
                <div class="txt">角色类型：</div>
                <div class="right">
                  <div class="con">{{ userCompanyCard.checkrole }}</div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">所属部门：</div>
                <div class="right">
                  <div class="con">{{ userCompanyCard.deptname }}</div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">角色关系：</div>
                <div class="right">
                  <div class="con">{{ userCompanyCard.rolename }}</div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">联系人：</div>
                <div class="right">
                  <div class="con">
                    {{
                      userCompanyCard.linkname ? userCompanyCard.linkname : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">联系电话：</div>
                <div class="right flex-between">
                  <div class="con">
                    {{
                      userCompanyCard.linkphone ? userCompanyCard.linkphone : ""
                    }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.linkphone"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">联系邮箱：</div>
                <div class="right flex-between">
                  <div class="con">
                    {{
                      userCompanyCard.linkemail ? userCompanyCard.linkemail : ""
                    }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.linkemail"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="txt">社会统一信用代码：</div>
                <div class="bottom flex-between">
                  <div class="con">
                    {{ userCompanyCard.uscc ? userCompanyCard.uscc : "" }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.uscc"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="company_down">
              <div class="row flex-rowl">
                <div class="txt">官方抖音ID：</div>
                <div class="right flex-between">
                  <div class="con">
                    {{
                      userCompanyCard.douyinid ? userCompanyCard.douyinid : ""
                    }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.douyinid"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">官方小红书ID：</div>
                <div class="right flex-between">
                  <div class="con">
                    {{
                      userCompanyCard.redbookid ? userCompanyCard.redbookid : ""
                    }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.redbookid"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
              <div class="row flex-rowl">
                <div class="txt">官方大众点评ID：</div>
                <div class="right flex-between">
                  <div class="con">
                    {{
                      userCompanyCard.dianpingid
                        ? userCompanyCard.dianpingid
                        : ""
                    }}
                  </div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.dianpingid"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="company_address">
              <div class="row flex-rowl">
                <div class="txt">所在地区：</div>
                <div class="right flex-between">
                  <div class="con" v-if="cityArea">
                    {{ cityArea }}
                    <!-- {{ userCompanyCard.city }} {{ userCompanyCard.area }} -->
                  </div>
                  <div class="place" v-else>省、市、自治区</div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="cityArea"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
              <div class="row row_address">
                <div class="txt">详细地址：</div>
                <div class="bottom flex-between">
                  <div class="con" v-if="userCompanyCard.addr">
                    {{ userCompanyCard.addr }}
                  </div>
                  <div class="place" v-else>区、街道、详细地址</div>
                  <div
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.addr"
                    @click="handleCopyBtn"
                  >
                    <i class="iconfont icon-fuzhi"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="company_appId">
              <div class="row flex-rowl">
                <div class="txt">关联小程序APPID：</div>
                <div class="right flex-between">
                  <div class="con" v-if="userCompanyCard.smallpid">
                    {{ userCompanyCard.smallpid }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="operation flex-rowl"
              v-if="userCompanyCard.checkrole == '创建人'"
            >
              <router-link
                to="/companyIndex/companyEdit"
                class="custom_btn flex-rowc"
                >企业/团队信息管理 <i class="iconfont icon-xinjian"></i
              ></router-link>
              <!-- <router-link
                :to="'/companyIndex/userList/' + userCompanyCard.id"
                class="custom_btn flex-rowc"
                >成员管理 <i class="iconfont icon-xingtuxuetang-jiaru-"></i
              ></router-link> --> 
              <div class="custom_btn flex-rowc" @click="handleGo('userList',{qyid: userCompanyCard.id})">成员管理 <i class="iconfont icon-xingtuxuetang-jiaru-"></i
              ></div>
            </div>
            <div class="operation flex-rowl" v-else>
              <div class="custom_btn" @click="handleExit">
                退出企业 <i class="iconfont icon-tuichu"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="btn_sj" v-if="userCompanyCard.checkrole == '创建人'" @click="handleGo('companyUserList',{qyid: userCompanyCard.id})">合作商家管理</div>
      <div class="btn_sj" v-if="userCompanyCard.checkrole == '创建人'" @click="handleGo('addRuleHPf',{qyguid: userCompanyCard.guid})">混批管理</div>
      <div class="btn_sj" v-if="userCompanyCard.checkrole == '创建人'" @click="handleGo('consumptionRule',{qyguid: userCompanyCard.guid})">消费规则管理</div>
      <router-link
        :to="'/companyIndex/poster'"
        class="btn_sj"
        v-if="userCompanyCard.checkrole == '创建人'"
        >业务海报模板管理</router-link
      >
      <div class="btn_sj" v-if="userCompanyCard.checkrole == '创建人'" @click="getQyNoticeList">业务通知管理设置</div>
      <!-- <router-link
        :to="'/companyIndex/companyUserList/' + userCompanyCard.id"
        class="btn_sj"
        v-if="userCompanyCard.checkrole == '创建人'"
        >合作商家管理</router-link
      >
      <router-link
        :to="'/companyIndex/addRuleHPf/' + userCompanyCard.id"
        class="btn_sj"
        v-if="userCompanyCard.checkrole == '创建人'"
        >混批管理</router-link
      >
       -->
    </div>

    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {encryptstringadd} from '../../api/api'
import {
  getCompanyInfo,
  userExitCompany,
  wx_editQy,
  wx_addQy,
  getQyNoticeList,
  addQyNotice,
  editQyNotice,
} from "../../api/company";
import { mapState } from "vuex";
import mythead from "../../components/head.vue";
export default {
  name: "companyManageDetail",
  components: { mythead },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      isLoading: true,
      PCA_address: "",
      userInfo: "",
      tuozhanInfo: "",
      userCompanyCard: {},
      cityArea: "",
      checkstate: 0, //0-审核中、1-已通过、2-拒绝加入、3-已退出、4-已被移除

      option: {}, //配置

      noticeId: "",
      noticeObj: {
        mobile_user: "",
        mobile_cmuser: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "userAgent", "qy_userId"]),
  },
  created() {
    this.getInit();
  },
  methods: {
    async getInit() {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // 获取用户
      let res1 = this.$store.state.USERINFO;
      this.userInfo = res1;
      // let provincename = res1.provincename ? res1.provincename : " ";
      // let cityname = res1.cityname ? res1.cityname : " ";
      // let areaname = res1.areaname ? res1.areaname : " ";
      // this.PCA_address = provincename + ' ' + cityname + ' ' + areaname;
      this.PCA_address =
        (res1.provincename ? res1.provincename : "") +
        " " +
        (res1.cityname ? res1.cityname : "") +
        " " +
        (res1.areaname ? res1.areaname : "");
      this.tuozhanInfo = res1.tuozhan[0];

      // 获取企业
      let res2 = await getCompanyInfo({
        openid: this.OPENID,
      });
      if (
        res2 != "false" &&
        (res2.checkstate == "已通过" ||
          res2.checkstate == "审核中" ||
          res2.checkstate == "拒绝加入")
      ) {
        this.userCompanyCard = res2;
        let provincename =
          res2.provincename &&
          res2.provincename != undefined &&
          res2.provincename != ""
            ? res2.provincename
            : "";
        let cityname =
          res2.cityname && res2.cityname != undefined && res2.cityname != ""
            ? res2.cityname
            : "";
        let arearname =
          res2.arearname && res2.arearname != undefined && res2.arearname != ""
            ? res2.arearname
            : "";
        this.cityArea = provincename + cityname + arearname;
      } else {
        this.userCompanyCard = {};
      }

      toast.clear();
      this.isLoading = false;
    },

    // 退出企业
    handleExit() {
      const toast = this.$toast.loading({
        message: "申请中...",
        forbidClick: true,
      });
      let { userCompanyCard, OPENID } = this;
      let params = {
        qyid: userCompanyCard.id,
        openid: OPENID,
      };
      userExitCompany(params).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.getQyNoticeList(false);
        } else {
          toast.clear();
          this.$toast.fail(res.message);
        }
      });
    },

    // 获取企业
    getCompany() {
      getCompanyInfo({ openid: this.OPENID }).then((res) => {
        if (
          res != "false" &&
          (res.checkstate == "已通过" ||
            res.checkstate == "审核中" ||
            res.checkstate == "拒绝加入")
        ) {
          this.userCompanyCard = res;
          let provincename =
            res.provincename &&
            res.provincename != undefined &&
            res.provincename != ""
              ? res.provincename
              : "";
          let cityname =
            res.cityname && res.cityname != undefined && res.cityname != ""
              ? res.cityname
              : "";
          let arearname =
            res.arearname && res.arearname != undefined && res.arearname != ""
              ? res.arearname
              : "";
          this.cityArea = provincename + cityname + arearname;
        } else {
          this.userCompanyCard = {};
        }
      });
    },

    // 获取企业业务设置
    getQyNoticeList(isClick) {
      let qyguid = this.userCompanyCard.guid;
      getQyNoticeList({ qyguid }).then((res) => {
        if (res.total == 0) {
          this.addQyNotice();
        } else {
          let newRes = res.list.length > 0 ? res.list[0] : "";
          this.noticeId = newRes.id;
          this.noticeObj.mobile_user = newRes.mobile_user
            ? newRes.mobile_user
            : "";
          this.noticeObj.mobile_cmuser = newRes.mobile_cmuser
            ? newRes.mobile_cmuser
            : "";
          this.noticeObj.mobile_sendgoods = newRes.mobile_sendgoods
            ? newRes.mobile_sendgoods
            : "";
          this.noticeObj.mobile_checkreturn = newRes.mobile_checkreturn
            ? newRes.mobile_checkreturn
            : "";
          for (let key in this.noticeObj) {
            if (
              this.noticeObj[key] ===
              this.userInfo.truename + " | " + this.userInfo.mobile
            ) {
              this.noticeObj[key] = "";
            }
          }
          if (isClick) {
            this.encryptstringadd("serviceNitoceManage", {
              qyguid: this.userCompanyCard.guid,
              qyid: this.userCompanyCard.id,
              id: res.list[0].id,
            });
          } else {
            this.editQyNotice();
          }
        }
      });
    },

    // 新增企业业务设置
    addQyNotice() {
      let params = {
        qyguid: this.userCompanyCard.guid,
        mobile_user: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      };
      addQyNotice(params).then((res) => {
        if (res.result) {
          this.getQyNoticeList(true);
        }
      });
    },

    // 修改企业业务设置
    editQyNotice() {
      let { noticeObj, noticeId } = this;
      let obj = {
        id: noticeId,
        qyguid: this.userCompanyCard.guid,
      };
      let mergedObj = { ...obj, ...noticeObj };
      editQyNotice(mergedObj).then((res) => {
        console.log(res, "--==--=");
      });
    },

    handleDetail(id) {
      this.$router.push(`/companyIndex/companyDetail/${id}`);
    },

    handleGo(name, params) {
      this.encryptstringadd(name, params)
    },  
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    handleReturn() {
      this.$router.back();
    },

    // 微信一键创建企业
    handleCreateQy() {
      let { qy_userId, OPENID, USERINFO } = this;
      let params = {
        userid: qy_userId,
        openid: OPENID,
        mobile: USERINFO.mobile,
        truename: USERINFO.truename,
      };
      const toast = this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      wx_editQy(params).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getCompany();
          }, 800);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 微信一键加入企业
    handleJoinQy() {
      let { OPENID } = this;
      let params = {
        openid: OPENID,
      };
      const toast = this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      wx_addQy(params).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getCompany();
          }, 800);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.minePage {
  padding-bottom: 400px;
  box-sizing: border-box;
  // .icon-edit {
  //   font-size: 30px;
  //   color: #333;
  // }
  .company_column {
    width: 670px;
    margin: 60px auto 0;
    .title {
      padding: 0 20px;
      color: #333333;
      font-size: 30px;
      margin-bottom: 45px;
      .edit {
        padding: 0 20px;
        height: 35px;
        border-radius: 25px;
        background: #f62560;
        font-size: 18px;
        color: #fff;
        .icon-edit {
          margin-right: 5px;
          color: #fff;
          // font-size: 20px;
        }
      }
    }
    .card_box {
      width: 600px;
      margin: auto;
      // box-shadow: 0px 0px 16px 0px rgba(10, 1, 3, 0.1);
      border: 1px solid #aaaaaa;
      // border-radius: 50px;
      background: #fff;
      box-sizing: border-box;
      font-size: 28px;
      color: #333333;
      position: relative;
      .no {
        padding: 92px 0;
        .custom_btn {
          width: 310px;
          margin: auto;
          font-size: 22px;
          &:last-child {
            margin-top: 70px;
          }
        }
      }
      .company_wrapper {
        padding: 50px 35px 50px;
        box-sizing: border-box;
        position: relative;
        font-size: 24px;
        .primary-button {
          height: 60px;
          line-height: 60px;
          font-size: 24px;
          margin: 50px auto;
        }
        .company_upper {
          .img_box {
            width: 160px;
            height: 160px;
            margin-right: 30px;
          }
          .intro {
            font-size: 24px;
            color: #333333;
            .row:nth-child(1) {
              margin-bottom: 22px;
            }
            .subTit {
              font-size: 20px;
              color: #969696;
              margin-bottom: 10px;
            }
          }
        }
        .company_content_info,
        .company_down,
        .company_address {
          margin: 50px 0 85px;
          .row {
            margin-bottom: 28px;
            &:last-child {
              margin-bottom: 0;
            }
            .right {
              flex: 1;
              flex-shrink: 0;
            }
            .bottom {
              margin-top: 10px;
            }
            .place {
              width: 100%;
            }
          }
        }
        .company_appId {
          margin: 50px 0 85px;
        }
        .certification_state {
          position: absolute;
          top: 20px;
          right: 15px;
          background: #bebebe;
          border-radius: 17px;
          color: #fff;
          font-size: 18px;
          height: 35px;
          line-height: 35px;
          padding: 0 28px 0 21px;
          .iconfont {
            font-size: 26px;
            margin-right: 5px;
          }
        }
        .place {
          font-size: 22px;
          color: #969696;
        }
        .operation {
          position: absolute;
          bottom: -20px;
        }
      }
      .custom_btn {
        height: 60px;
        line-height: 60px;
        padding: 0 35px 0 36px;
        box-sizing: border-box;
        width: auto;
        margin-right: 15px;
        .icon-xinjian {
          font-size: 34px;
          margin-left: 7px;
        }
        .icon-xingtuxuetang-jiaru- {
          font-size: 30px;
          margin-left: 7px;
        }
        .icon-tuichu {
          font-size: 24px;
          margin-left: 7px;
          font-weight: bold;
        }
      }
    }
    .wx_register {
      font-size: 28px;
      color: #333333;
      width: 600px;
      height: 110px;
      border: 1px solid #aaaaaa;
      margin: 50px auto 0;
      .icon {
        width: 43px;
        height: 35px;
        margin-right: 28px;
      }
      span {
        font-size: 28px;
        color: #f30930;
        font-weight: bold;
        margin-left: 4px;
      }
    }
    .btn_group {
      margin-bottom: 120px;
    }
  }
  .column_wrap {
    .btn {
      width: 600px;
      height: 110px;
      border: 1px solid #aaaaaa;
      font-size: 28px;
      color: #333333;
      margin: 0 auto 50px;
      padding-left: 155px;
      box-sizing: border-box;
      &:last-child {
        margin-top: 100px;
      }
      .user_icon {
        width: 34px;
        height: 35px;
        margin-right: 18px;
      }
      .qy_icon {
        width: 43px;
        height: 35px;
        margin-right: 18px;
      }
      .iconfont {
        margin-right: 20px;
      }
      .icon-anquan {
        font-size: 44px;
      }
      .icon-yonghu {
        font-size: 36px;
      }
      .icon-tuichu {
        font-size: 40px;
        font-weight: 600;
      }
    }
  }
  .custom_btn {
    margin-top: 150px;
  }
  .btn_sj {
    display: block;
    width: 600px;
    height: 110px;
    line-height: 110px;
    border: 1px solid #aaaaaa;
    font-size: 28px;
    color: #333333;
    margin: auto;
    box-sizing: border-box;
    text-align: center;
    &:first-child {
      margin: 80px auto 50px;
    }
    margin-bottom: 50px;
  }
}
</style>